<ng-container>
  <tr [ngClass]="cssClassName">
    <td easEditorBookingItemInheritableTypeHeader [inheritableType]="itemSetting.inheritableType">
      {{ itemSetting.getTitle() }}
    </td>
    <td>
      @if (itemSetting.inheritableType === 'empty') {
        <span class="text-muted" i18n>
        Not set
      </span>
      }
      @if (itemSetting.inheritableType !== 'empty') {
        @switch (itemSetting.settingClassName) {
          @case ('BookingDate') {
            <eas-editor-booking-item-setting-value-booking-date [itemSetting]="itemSetting">
            </eas-editor-booking-item-setting-value-booking-date>
          }
          @case ('BookingWindow') {
            <eas-editor-booking-item-setting-value-booking-window [itemSetting]="itemSetting">
            </eas-editor-booking-item-setting-value-booking-window>
          }
          @case ('Capacity') {
            <eas-editor-booking-item-setting-value-capacity [itemSetting]="itemSetting">
            </eas-editor-booking-item-setting-value-capacity>
          }
          @case ('Eligibility') {
            <eas-editor-booking-item-setting-value-eligibility [itemSetting]="itemSetting">
            </eas-editor-booking-item-setting-value-eligibility>
          }
          @case ('Pricing') {
            <eas-editor-booking-item-setting-value-pricing [itemSetting]="itemSetting">
            </eas-editor-booking-item-setting-value-pricing>
          }
          @case ('Venue') {
            <eas-editor-booking-item-setting-value-venue [itemSetting]="itemSetting">
            </eas-editor-booking-item-setting-value-venue>
          }
          @case ('Workflow') {
            <eas-editor-booking-item-setting-value-workflow [itemSetting]="itemSetting">
            </eas-editor-booking-item-setting-value-workflow>
          }
        }
      }
      <button mat-icon-button
        aria-label="Edit setting"
        i18n-aria-label
        (click)="onEdit()">
        <mat-icon>edit</mat-icon>
      </button>
    </td>
    <td>
      @if (itemSetting.inheritableType !== 'empty') {
        <eas-editor-booking-item-inheritable-type-badge [inheritableType]="itemSetting.inheritableType">
        </eas-editor-booking-item-inheritable-type-badge>
      }
    </td>
  </tr>
</ng-container>
